import React, { useEffect, useRef, useState, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap"
import { customerIdData } from "../../Customers/constants/constantFunctionsView";
import { Form, Formik } from "formik";
import { validationSchema } from "./constants/ValidationSchema";
import { onSubmit } from "./constants/AttributeJsonObj";
import AttributeDetails from "./AttributeDetails";
import CommonButton from "../../Utils/CommonButton";
import { getAttributeByName } from "../../../slices/attribute/getattributebyname/thunk";
import { Loader } from "../../Utils/Loader";
import { getAllAttribute } from "../../../slices/services/addservice/provisionalattribute/thunk";
import { hasPermission } from "../../Utils/UtilityFunctions";
import { getAllCategory } from "../../../slices/Category/GetCategory/thunk";

export const AttributeModal = ({ attributeModalOpen, setAttributeModalOpen, isEdit, setIsEdit, editAttribute, setEditAttribute }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [loading, setLoading] = useState()
    const [checked, setIsChecked] = useState()
    const [mandatoryChecked, setMandatoryIsChecked] = useState()
    const [mandatoryCheckedPersistence, setMandatoryIsCheckedPersistence] = useState()
    const [mandatoryCheckedSelfcare, setMandatoryIsCheckedSelfcare] = useState()

    const rawPermissions = useSelector(
    (state) => state.permissions.permissionsMap
    );

    const permissionsMap = useMemo(() => {
    return new Map(
        rawPermissions.map(([key, value]) => [key, new Set(value)])
    );
    }, [rawPermissions]);

    const attributeInventoryPermission = useMemo(() => {
    return hasPermission(
        permissionsMap,
        "configuration",
        "attribute"
    );
    }, [permissionsMap]);

    const categoryData = useSelector(
    (state) => state.Category.categories
    );

    useEffect(() => {
    if (
        attributeModalOpen &&
        attributeInventoryPermission?.has("list")
    ) {
        dispatch(getAllCategory(setLoading));
    }
    }, [attributeModalOpen, attributeInventoryPermission, dispatch]);

   const categoryOptions = useMemo(() => {
    if (!Array.isArray(categoryData)) return [];

    return categoryData
        .map((cat) => {
            const value = typeof cat === "string" ? cat : cat?.name;

            return value
                ? { label: value, value: value }
                : null;
        })
        .filter(Boolean);
}, [categoryData]);

    const attribute = customerIdData()
    const [state, setState] = useState()
    const formRef = useRef();
    const [formValues, setFormValues] = useState({
        name: "",
        type: "",
        valueType: "",
        description: "",
        attributeValue: "",
        defaultValue: "",
        minimumValue: "",
        maximumValue: "",
        SelfcareAttribute: "",
        networkField: "",
    });
    const [initialValues, setInitialValues] = useState({
        name: "",
        type: "",
        valueType: "",
        description: "",
        attributeValue: "",
        defaultValue: "",
        minimumValue: "",
        maximumValue: "",
        sequenceValue: "",
        SelfcareAttribute: "",
        networkField: "",
        category: [],
    });
    const toggle = () => {
        formRef?.current?.resetForm();
        setAttributeModalOpen(false);
        setMandatoryIsCheckedPersistence(false);
        setMandatoryIsCheckedSelfcare(false)
        setMandatoryIsChecked(false)
        setIsEdit(false)
        setEditAttribute(null)
        dispatch(getAllAttribute(setLoading))
        setInitialValues({
            name: "",
            type: "",
            valueType: "",
            description: "",
            attributeValue: "",
            defaultValue: "",
            minimumValue: "",
            maximumValue: "",
            sequenceValue: "",
            SelfcareAttribute: "",
            networkField: "",
        })
        setFormValues({
            name: "",
            type: "",
            valueType: "",
            description: "",
            attributeValue: "",
            defaultValue: "",
            minimumValue: "",
            maximumValue: "",
            SelfcareAttribute: "",
            networkField: "",
        });
    }

    useEffect(() => {
        if (isEdit) {
            dispatch(getAttributeByName(editAttribute, setLoading, setInitialValues))
        }
    }, [dispatch, isEdit, editAttribute])
    const getAttributeDataByName = useSelector((state) => state.GetAttributeByName.getAttribute)
    useEffect(() => {
        if (isEdit) {
            if (getAttributeDataByName?.searchable === true) {
                setIsChecked(true)
            }
            else {
                setIsChecked(false)
            }
            if (getAttributeDataByName?.mandatory === true) {
                setMandatoryIsChecked(true)
            }
            else {
                setMandatoryIsChecked(false)
            }
            if (getAttributeDataByName?.selfcareVisible === true) {
                setMandatoryIsCheckedSelfcare(true)
            }
            else {
                setMandatoryIsCheckedSelfcare(false)
            }
            if (getAttributeDataByName?.ratedEventPersistance === true) {
                setMandatoryIsCheckedPersistence(true)
            }
            else {
                setMandatoryIsCheckedPersistence(false)
            }
        }
    }, [getAttributeDataByName, isEdit])
    return (
        <div>
            <React.Fragment>
                <Formik
                    innerRef={formRef}
                    enableReinitialize
                    validationSchema={attributeModalOpen ? validationSchema(state, formValues) : null}
                    initialValues={initialValues}
                    onSubmit={onSubmit(dispatch, setLoading, navigate, isEdit, editAttribute, checked, mandatoryChecked, mandatoryCheckedSelfcare, mandatoryCheckedPersistence, toggle)}
                >
                    {({ handleChange, handleBlur, handleSubmit, errors, touched, values, setFieldValue, setFieldTouched, setFieldError, resetForm }) => {
                        useEffect(() => {
                            setFormValues(values);
                        }, [values]);
                        return (
                            <Form className='needs-validation'>
                                <Modal isOpen={attributeModalOpen} toggle={toggle} className="rv-modal attribute-modal" size="lg" centered backdrop="static" onKeyDown={(e) => {
                                    if (e.key === "Enter" && !e.shiftKey) {
                                        e.preventDefault();
                                        handleSubmit();
                                    }
                                }}>
                                    <ModalHeader className="d-flex align-items-center mb-0 pb-0">
                                        {isEdit ? "Edit Attribute" : "Add Attribute"}
                                        <button type="button" className="close-button-currency mt-n1 fs-1" onClick={toggle}>
                                            &times;
                                        </button>
                                    </ModalHeader>
                                    <ModalBody className="modal-body mt-0 pt-0" style={{ maxHeight: "60vh", overflowY: "auto" }}>
                                        <Row className="me-1">
                                            {loading && (<Loader />)}
                                            <Col lg={12}>
                                                <AttributeDetails setState={setState} setMandatoryIsChecked={setMandatoryIsChecked} setMandatoryIsCheckedSelfcare={setMandatoryIsCheckedSelfcare} mandatoryCheckedSelfcare={mandatoryCheckedSelfcare} mandatoryChecked={mandatoryChecked} checked={checked} setIsChecked={setIsChecked} values={values} errors={errors} touched={touched} setFieldTouched={setFieldTouched} setFieldValue={setFieldValue} handleBlur={handleBlur} handleChange={handleChange} setFieldError={setFieldError} mandatoryCheckedPersistence={mandatoryCheckedPersistence} setMandatoryIsCheckedPersistence={setMandatoryIsCheckedPersistence} isEdit={isEdit} isChecked={checked} categoryOptions={categoryOptions}/>
                                            </Col>
                                        </Row>
                                    </ModalBody>
                                    <ModalFooter className="justify-content-center">
                                        <div className="d-flex gap-2 justify-content-center">
                                            <CommonButton
                                                outline={true}
                                                className={
                                                    "btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                                                }
                                                color={"main-color"}
                                                type={"reset"}
                                                buttonAction={() => {
                                                    resetForm();
                                                    toggle();
                                                }}
                                                buttonText={"Cancel"}
                                                icon={
                                                    <i className="ri-close-fill label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                                }
                                                btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
                                            />
                                            <CommonButton
                                                color={"main-color"}
                                                className={
                                                    "btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                                                }
                                                icon={
                                                    <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-2"></i>
                                                }
                                                btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
                                                buttonAction={handleSubmit}
                                                buttonText={"Submit"}
                                            />
                                        </div>
                                    </ModalFooter>
                                </Modal>
                            </Form>
                        )
                    }}
                </Formik>

            </React.Fragment>
        </div>
    )
}